import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { SingleInventoryItem, AllocationOption } from 'common/modules/inventory';
import { useWatch, useFormContext, Controller } from 'react-hook-form';
import {
	allocationOptionValues,
	getInventoryAllocationOptionTranslation,
} from 'views/Inventory/utils';
import { useTranslation } from 'services/localization';

interface Props {
	item: SingleInventoryItem;
	allocation: AllocationOption;
}

const SingleAllocation = (props: Props) => {
	const { control } = useFormContext();
	const { t } = useTranslation();

	const allocation: AllocationOption = useWatch({
		control,
		name: 'allocation',
		defaultValue: props.allocation,
	});
	const classes = useStyles({ allocation });

	return (
		<Controller
			name="allocation"
			render={(renderProps) => (
				<Select
					value={renderProps.field.value}
					onChange={renderProps.field.onChange}
					variant="outlined"
					fullWidth
					classes={{
						select: classes.select,
					}}
					inputProps={{
						classes: {
							focused: classes.select,
						},
					}}
				>
					{allocationOptionValues.map((allocation, idx) => {
						return (
							<MenuItem key={`${allocation}${idx}`} value={allocation}>
								{getInventoryAllocationOptionTranslation(t, allocation)}
							</MenuItem>
						);
					})}
				</Select>
			)}
		/>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		select: {},
	}),
);

export default SingleAllocation;
